import { HTMLAttributes, useCallback, useEffect, useState } from 'react'
import parse from 'html-react-parser'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Spinner from '@/components/base/Spinner'
import { axiosClient as axios } from '@/base/axios'

import { WPPageData } from '@/types'

export type PolicyProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Policy = ({ pageData }: PolicyProps) => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState('')
  const getData = useCallback(async (endpoint: string) => {
    if (!endpoint) return

    setLoading(true)

    const { data } = await axios.get(endpoint)

    if (!data || data.length === 0) return

    setData(data.content)

    setLoading(false)
  }, [])

  useEffect(() => {
    getData(pageData?.acf?.policy_endpoint || '')
  }, [])

  return pageData?.acf?.policy_endpoint ? (
    <Container>
      <Grid>
        <div className="col-span-4 pt-header-height md:col-span-6 lg:col-span-12">
          {isLoading ? (
            <div className="flex w-full justify-center">
              <Spinner theme="light" variant="small" />
            </div>
          ) : (
            parse(data)
          )}
        </div>
      </Grid>
    </Container>
  ) : null
}

export default Policy
